<template>
  <div>
    <HeroImageOrVideo v-if="imageSrc" :image="imageSrc">
      <div class="container flex items-center h-full flex-wrap">
        <div :class="{ 'mac-os': isMac }">
          <h1 class="fluid-4xl leading-none">
            <span class="text__bg">{{ entry.title }}</span>
          </h1>
          <CtaArrow
            v-if="entry.parent"
            :to="$localeRootPath(entry.parent.uri)"
            :text="entry.storyLinkTitle || entry.parent.title"
            class="mt-4 block mx-4"
          />
        </div>
      </div>
    </HeroImageOrVideo>
    <ContentBlocks :entry="entry" :social-media-accounts="socialMediaAccounts" />
  </div>
</template>
<script>
import gql from 'graphql-tag';
import HeroImageOrVideo from '@/components/common/HeroImageOrVideo';
import CtaArrow from '@/components/common/CtaArrow';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';

export const StoriesCategoryPageFragment = gql`
  fragment StoriesCategoryPageFragment on storiesCategory_Entry {
    title
    seoTopics
    storyLinkTitle
    image: headerImageOrVideo {
      url
      kind
    }
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
  }
  ${ContentBlocksMatrixFragment}
`;

export default defineNuxtComponent({
  name: 'StoriesCategoryPage',
  components: { HeroImageOrVideo, ContentBlocks, CtaArrow },
  props: {
    entry: {
      type: Object,
      default: () => {},
    },
    socialMediaAccounts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    imageSrc() {
      return this.entry?.image?.length ? this.entry?.image[0] : null;
    },
    isMac() {
      return process.browser && navigator.userAgent?.indexOf('Mac OS X') !== -1;
    },
  },
});
</script>
